export const DEFAULT_MAX_RETRY = 5;
export const DEFAULT_RETRY_DELAY = 300;
